// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1702977182445
      var cssReload = require("E:/下载/Edge下载/HBuilderX/plugins/uniapp-cli/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  